module.exports = __webpack_public_path__ + "aa1f9e6e38bb9331476bd472fc50d740.pdf";